import { render, staticRenderFns } from "./yqm-list.vue?vue&type=template&id=08065073&"
import script from "./yqm-list.vue?vue&type=script&lang=ts&"
export * from "./yqm-list.vue?vue&type=script&lang=ts&"
import style0 from "./yqm-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports